// capturador de errores

import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    setTimeout(() => {
      this.setState({ hasError: false, error: null });
    }, 5000);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-warning m-3">
          <strong>Temporary delay reading.</strong> Reloading...
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;